module.exports = __webpack_public_path__ + "static/media/account_placeholder.6732bd42.png";